import React, { useState, useCallback, useRef, useEffect } from 'react';
import PropTypes from 'prop-types';
import useConstructor from '../../../hooks/useConstructor';
import Advertisment from '.';
import useScroll from '../../../hooks/useScroll';
import { getMetaContent, isNoticia } from '../../../utils';
import { ReactComponent as Close } from '../../../assets/icons/close-window-neutro.svg';

const pathRegex = /^\/(([^/])+\/){0,2}/;
const STICKY_DISABLE_TIMEOUT = 8000;

const AdvertismentWidget = props => {
  const {
    sizesd,
    sizesm,
    sizest,
    position,
    id,
    stickyd,
    widget,
    adUnit
  } = props;
  const [posi, setPosi] = useState('');
  const [adUnitSub, setAdUnitSub] = useState('');
  const [stickyTop, setStickyTop] = useState(false);
  const [visible, setVisible] = useState(true);
  const containerRef = useRef();

  // Usamos esta funcion para quitar el numero que mete back al final de data-position
  const getNormalizedPosition = pos => {
    if (pos && pos.includes('top')) {
      return 'top';
    }
    if (pos && pos.includes('roba')) {
      return 'roba';
    }

    return 'middle';
  };

  const pos = useRef(getNormalizedPosition(position)).current;

  const refs = useRef({
    headerId: document.querySelector('#header'),
    header: document.querySelector('header.header'),
    modSticky: widget ? widget.closest('.mod-sticky') : null,
    timeout: null,
    stickyTopActive: true
  });

  const { header, headerId, modSticky } = refs.current;

  const handleScroll = useRef(({ dir }) => {
    const container = containerRef.current;
    if (container) {
      const { top } = container.getBoundingClientRect();
      const { bottom } = header.getBoundingClientRect();

      const { timeout, stickyTopActive } = refs.current;

      if (top <= bottom && dir === 'down' && stickyTopActive) {
        setStickyTop(sticky => {
          if (!sticky) {
            if (timeout) {
              clearTimeout(timeout);
            }
            refs.current.timeout = setTimeout(() => {
              setStickyTop(false);
              headerId.classList.remove('adv-top-sticky');
              refs.current.stickyTopActive = false;
            }, STICKY_DISABLE_TIMEOUT);
          }
          headerId.classList.add('adv-top-sticky');
          return true;
        });
      } else if (top > 0) {
        if (timeout) {
          clearTimeout(timeout);
        }
        setStickyTop(false);
      }
    }
  }).current;

  useScroll({ onScroll: position === 'top1' ? handleScroll : undefined });

  const controlKeys = useCallback(
    elements => {
      const IDsequals = [];
      const ArrayIds = elements.map(ad => ad.id);
      const ArrayIndex = ArrayIds.indexOf(id);
      for (let x = 0; x <= ArrayIndex; x += 1) {
        if (
          getNormalizedPosition(elements[x].getAttribute('data-position')) ===
          pos
        ) {
          IDsequals.push(ArrayIds[x]);
        }
      }
      setPosi(`${pos}${IDsequals.length}`);
    },
    [pos, id]
  );

  const controlAdUnit = useCallback(() => {
    const path = window.location.pathname;
    const match = path.match(pathRegex)[0];

    if (match === '/') {
      return '/home';
    }

    return match.endsWith('/') ? match.slice(0, -1) : match;
  }, []);

  const controlDevice = useCallback(
    w => {
      if (w) {
        if (w >= 1024 && sizesd) {
          controlKeys(
            Array.from(
              document.querySelectorAll(
                'atres-widget[data-type=ads][data-sizesd]'
              )
            )
          );
          return sizesd;
        }
        if (w <= 767 && sizesm) {
          controlKeys(
            Array.from(
              document.querySelectorAll(
                'atres-widget[data-type=ads][data-sizesm]'
              )
            )
          );
          return sizesm;
        }
        if (w >= 768 && w <= 1023 && sizest) {
          controlKeys(
            Array.from(
              document.querySelectorAll(
                'atres-widget[data-type=ads][data-sizest]'
              )
            )
          );
          return sizest;
        }
      }
      return null;
    },
    [controlKeys, sizesd, sizest, sizesm]
  );

  const [sizes, setSizes] = useState();

  useConstructor(() => {
    setSizes(
      controlDevice(window.screen.width)
        ? controlDevice(window.screen.width)
            .split(',')
            .map(size =>
              size
                .split('x')
                .map(dimension =>
                  dimension.includes('fluid')
                    ? dimension
                    : parseInt(dimension, 10)
                )
            )
        : null
    );
    setAdUnitSub(controlAdUnit());
    if (stickyd && modSticky) {
      modSticky.classList.add('mod-sticky--active');
    }
  });

  const handleCloseAd = useCallback(() => {
    setVisible(false);
  }, []);

  useEffect(
    () => () => {
      const { timeout } = refs.current;
      if (timeout) {
        clearTimeout(timeout);
      }
    },
    []
  );

  const handleLoad = useCallback(
    (containerId, event) => {
      try {
        const adId = event.slot.getSlotElementId();
        if (
          widget &&
          position === 'top1' &&
          (adId === containerId || adId === 'gpt-passback')
        ) {
          const data = widget.firstElementChild.getBoundingClientRect();
          widget.style.height = `${data.height}px`;
          widget.style.display = `block`;
          // Fix para ads con height:auto
          const gptContainer = widget.querySelector('.gpt-container');
          if (
            gptContainer &&
            gptContainer.firstElementChild
              .getAttribute('style')
              .includes('height: auto')
          ) {
            widget.style.height = 'auto';
          }
        }
      } catch (e) {
        console.error(`Failed to assign ad height`);
      }
    },
    [widget, position]
  );

  return (
    sizes && (
      <div
        data-stickyd="true"
        className={`addContainer ${stickyd ? 'addContainer--sticky' : ''} ${
          stickyTop && visible ? 'addContainer--top-sticky' : ''
        } ${props.breadcrumbAlign ? 'addContainer--breadcrumb-align' : ''}`}
        ref={containerRef}
      >
        <p className="add-tag">
          <span className="add-tag-txt">Publicidad</span>
        </p>
        {!props.static ? (
          <Advertisment
            adUnit={getMetaContent('ad-unit') || `${adUnit}${adUnitSub}`}
            keys={isNoticia() || pos === 'top' ? position : posi}
            sizes={sizes}
            lazy={!!props.lazy}
            id={props.id}
            onLoad={handleLoad}
          />
        ) : (
          <div className="gpt-container">
            <img src={props.static} alt="publicidad" />
          </div>
        )}
        {position === 'top1' && (
          <>
            <button
              onClick={handleCloseAd}
              className="add-close-btn"
              type="button"
            >
              <Close />
            </button>
          </>
        )}
      </div>
    )
  );
};

AdvertismentWidget.propTypes = {
  position: PropTypes.string,
  sizesm: PropTypes.string,
  sizest: PropTypes.string,
  sizesd: PropTypes.string,
  static: PropTypes.string,
  lazy: PropTypes.string,
  id: PropTypes.string,
  stickyd: PropTypes.bool,
  // adUnit: PropTypes.string,
  widget: PropTypes.node.isRequired,
  breadcrumbAlign: PropTypes.bool // alinea el banner de publicidad con el breadcrumb
};

AdvertismentWidget.defaultProps = {
  static: undefined,
  id: undefined,
  lazy: undefined,
  position: undefined,
  sizesm: undefined,
  sizest: undefined,
  sizesd: undefined,
  stickyd: false,
  adUnit: '',
  breadcrumbAlign: false
};

export default AdvertismentWidget;
